import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { comics } from '@/mocks/comics';

export default function FeaturedGrid() {
  const { t } = useTranslation();
  const featured = comics.filter((c) => c.featured).slice(0, 4);

  if (featured.length < 4) return null;

  const [main, ...rest] = featured;

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-16 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-2">
          {t('home.featuredTitle')}
          <span className="text-primary-500"> {t('home.featuredTitleHighlight')}</span>
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          精选高分漫画，每一部都值得细细品味
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Link
            to={`/comic/${main.slug}`}
            className="group relative overflow-hidden rounded-lg aspect-[4/5] md:aspect-auto cursor-pointer"
          >
            <img
              src={main.cover}
              alt={main.title}
              title={`${main.title} - 八仔漫画网`}
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-accent-500 text-white mb-3">
                {main.category}
              </span>
              <h3 className="text-xl md:text-2xl font-heading font-bold text-white mb-1">
                {main.title}
              </h3>
              <p className="text-sm text-white/70 line-clamp-2">
                {main.description}
              </p>
            </div>
          </Link>

          <div className="grid grid-rows-2 gap-4">
            {rest.map((comic) => (
              <Link
                key={comic.id}
                to={`/comic/${comic.slug}`}
                className="group relative overflow-hidden rounded-lg cursor-pointer"
              >
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 八仔漫画网`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/15 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium bg-accent-500/90 text-white mb-2">
                    {comic.category}
                  </span>
                  <h3 className="text-lg md:text-xl font-heading font-bold text-white">
                    {comic.title}
                  </h3>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}